import { render } from "./GridBody.vue?vue&type=template&id=4a6a8b71&scoped=true&ts=true"
import script from "./GridBody.vue?vue&type=script&lang=tsx"
export * from "./GridBody.vue?vue&type=script&lang=tsx"

import "./GridBody.vue?vue&type=style&index=0&id=4a6a8b71&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6a8b71"]])

export default __exports__